import React from 'react';
export default function Stub() { return null; }
